import { RoutingService } from '@client/services/routing';

// Truthy with no >=400 status is success; a cancelled request resolves undefined.
const ok = (res) => !!res && !(res.status >= 400);

/**
 * Builds the save payload for one route, mirroring the single-route `onSave()`
 * in `route/route.svelte`. The endpoint takes a 0-based priority, while the page
 * numbers routes from 1 for display.
 *
 * @param {Object} route The route as held by the page.
 * @param {Object[]} senderGroups Every group, used to resolve the selected names.
 * @param {boolean} status The status to save.
 * @returns {Object}
 */
export const buildRoutePayload = (route, senderGroups, status) => {
  const tags = (route.selectedTags || []).map(({ value }) => ({ text: value }));
  const selectedGroups = (route.selectedGroups || []).map(({ value }) => value);
  const sendergroups = senderGroups.filter(({ groupname }) => selectedGroups.includes(groupname));
  const { blockname, tagblock = {}, _id } = route;

  return {
    _id,
    blockname,
    hide: route.hide,
    priority: route.priority - 1,
    sendergroups,
    status,
    tagblock,
    tags
  };
};

/**
 * Keyed by the action strings `RouteSelectionControls` emits, so the page can
 * dispatch with `routeRunners[action]`.
 */
export const routeRunners = {
  enable: async (route, senderGroups) =>
    ok(await RoutingService.updateRoute(buildRoutePayload(route, senderGroups, true))),
  disable: async (route, senderGroups) =>
    ok(await RoutingService.updateRoute(buildRoutePayload(route, senderGroups, false))),
  delete: async (route) => ok(await RoutingService.deleteRoute(route))
};
